<template>
  <div class="real-time-pie">
    <p class="pie-device-status">{{$t('zhi_fu_fang_shi_fen_bu')}}</p>
    <div class="real-time-pie-chart">
      <div class="chart" id="payStylePieChart"></div>
      <div class="device-info clearfix">
        <div class="device-info-item">
          <p><span class="circle normal"></span> {{$t('zhi_fu_ding_dan')}}</p>
          <p class="device-number"> {{data.payOrder}}</p>
        </div>
        <div class="device-info-item">
          <p><span class="circle offline"></span> {{$t('fei_zhi_fu_ding_dan')}}</p>
          <p class="device-number"> {{data.notPayOrder}}</p>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
  import echarts from 'echarts'
  import pie from './pie'
  import {randomNum} from '@/util/random'

  export default {

    data() {
      return {
        pie,
        data: {
          payOrder: 0,
          notPayOrder: 0,
        },
        myChart: null,
      }
    },
    methods: {
      init() {
        this.myChart = echarts.init(document.getElementById('payStylePieChart'));
        this.myChart.setOption(this.pie)
      },
      setOrder(pay, notPay) {
        this.data.payOrder = pay
        this.data.notPayOrder = notPay
        this.pie.series.data[0].value = pay
        this.pie.series.data[1].value = notPay
        this.myChart.setOption(this.pie)
      },
    },

    mounted() {
      this.init()
    },
    beforeDestroy() {
      this.myChart.clear()
    },
    watch: {
      series() {

      }
    }
  }
</script>

<style lang="scss">
  .real-time-pie {
    padding: $padding;

    .pie-device-status {
      font-size: $small_font_size;
      font-weight: $w1;
      color: $f_sec_color;
    }

    .real-time-pie-chart {
      display: flex;
      height: 100%;

      .chart {
        flex: 1;
      }

      .device-info {
        width: 36%;
      }
    }

    .circle {
      display: inline-block;
      width: $small_font_size;
      height: $small_font_size;
      border-radius: $small_font_size;
    }

    .normal {
      background-color: #5AD8A6;
    }

    .fault {
      background-color: #E8684A;
    }

    .warning {
      background-color: #F6BD16;
    }

    .offline {
      background-color: #5B8FF9;
    }

    .device-info {
      font-size: $small_font_size;
      padding-top: $padding;

      .device-info-item {
        width: 100%;
        float: left;
        margin-bottom: $padding;
        padding-left: $padding;

        * {
          color: $f_sec_color;
        }

        .device-number {
          color: $f_th_color;
          font-size: $font_size;
          margin: $padding-2 $padding;
          margin-bottom: $padding-5;

        }
      }
    }
  }
</style>
